import $ from "jquery";
import BD_Question from "@bd-components/bd-question";

export class QuestionHotspotChoice extends BD_Question {
  constructor(questionData) {
    super();

    this.questionData = questionData;
    
    this.elms = {
      submit: ".js-submit",
      questionCard: ".questionCard",
      answer: ".js-answer",
    };
  }

  getAnswer(ctx) {
    return $(ctx.elms.answer.concat(".is-selected")).attr("data-value");
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.answer,
        handler: this.onSelectAnswer,
        isQuestionEvent: true,
      },
    ];
  }

  onSelectAnswer(e) {
    const $this = $(e.target);
    const $parent = $this.parents('.js-answer');

    $(this.elms.answer).parent().removeClass('is-selected');
    $parent.addClass('is-selected');

    $('#submitAnswer').trigger("click");
  }
}
